import { plainToInstance } from 'class-transformer'

import ReactionButtonBuilder, { ReactionButton, ReactionButtonData } from '../Reaction'
import { ButtonTypes } from '../types'

export default class FingerDownReactionButtonBuilder extends ReactionButtonBuilder {
  type = ButtonTypes.FingerDownReaction

  titleKey = ButtonTypes.FingerDownReaction

  icon = '👎'

  getData(button?: ReactionButton): ReactionButtonData {
    return new ReactionButtonData(button ?? plainToInstance(ReactionButton, {
      text: '👎',
      onlyUnique: true,
      grouped: true,
    }))
  }
}
